import React, { useEffect, Suspense, lazy } from 'react';
// import logo from './logo.svg';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import TagManager from 'react-gtm-module';
import VelarisGlobalLoader from './components/Loaders/FullscreenLoader';
import Login from './pages/Login/Login';

import '@velaris-csm/easy-email-extensions/lib/style.css';
import '@arco-themes/react-easy-email-theme/css/arco.css';
import '@velaris-csm/easy-email-editor/lib/style.css';

import 'antd/dist/antd.css';
import './styles/App.scss';

import { restoreSession } from './store/routines';
import SessionExpiredNotification from './components/Notification/SessionExpiredNotification';
import ErrorBoundaryWrapper from './components/ErrorState/ErrorBoundaryWrapper';
import envConfig from './config';
import withClearCache from './ClearCache';

const tagManagerArgs = {
  gtmId: `${envConfig.GTAG_MGR_ID}`,
};
TagManager.initialize(tagManagerArgs);

const RootContainer = lazy(() => import('./pages/RootContainer'));

const PrivateRoute = (allProps) => {
  return (
    <Route
      {...allProps} // eslint-disable-line react/jsx-props-no-spreading
      render={(props) =>
        allProps.isValidSession ? (
          <RootContainer {...props} /> // eslint-disable-line react/jsx-props-no-spreading
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

const AppContent = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(restoreSession());
  }, [dispatch]);

  const isValidSession = useSelector((state) => state.auth.isValidSession);
  const auth = useSelector((state) => state.auth);
  if (auth.isLoading) {
    return <VelarisGlobalLoader />;
  }
  return (
    <Router>
      <SessionExpiredNotification />
      <Suspense fallback={<VelarisGlobalLoader />}>
        <Switch>
          <PrivateRoute path="/app" isValidSession={isValidSession} />
          <Route path="*">
            <ErrorBoundaryWrapper resetKey="*">
              <Login />
            </ErrorBoundaryWrapper>
          </Route>
        </Switch>
      </Suspense>
    </Router>
  );
};

const ClearCacheComponent = withClearCache(AppContent);

function App() {
  return <ClearCacheComponent />;
}

export default App;

PrivateRoute.defaultProps = {
  location: {},
};

PrivateRoute.propTypes = {
  location: PropTypes.object,
};
